"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Period_1 = __importDefault(require("../entity/Period"));
const luxon_1 = require("luxon");
class PeriodStub extends Period_1.default {
    constructor({ from = luxon_1.DateTime.fromISO('2019-01-01T00:00:00'), to = luxon_1.DateTime.fromISO('2019-02-01T00:00:00'), } = {}) {
        super({ from, to });
    }
}
exports.default = PeriodStub;
